module.exports = __webpack_public_path__ + "static/media/uk.e2132738.png";